import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { AbstractFeatureEntityStore } from '@y42/feature';
import { VisualizationFilterGitFactoryService } from './visualization-filter-git-factory.service';
import { VisualizationFilterState } from './visualization-filter.model';

const initialState: VisualizationFilterState = {
  loading: true,
  last_used: {},
  starred: {},
  ui: {},
  active: null,
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'visualization-filter', idKey: '$path' })
export class VisualizationFilterStore extends AbstractFeatureEntityStore<VisualizationFilterState> {
  constructor(protected readonly gitFactory: VisualizationFilterGitFactoryService) {
    super({ name: 'Visualization-Filter', gitFactory, initialState });
  }
}
